module.exports = __webpack_public_path__ + "img/cross-dark.c09cfa6a.svg";